import { VideoOutput } from '../../../team-apis/otterdam/outputs/video-output';
import { AbstractSensorContentState2D } from '../../shared/state/abstract-sensor-content-state-2d';

export class VideoContentState extends AbstractSensorContentState2D {
  override output!: VideoOutput;
}
